import { render, staticRenderFns } from "./SelectRetailersStep.vue?vue&type=template&id=5356661c&scoped=true&"
import script from "./SelectRetailersStep.vue?vue&type=script&lang=js&"
export * from "./SelectRetailersStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectRetailersStep.vue?vue&type=style&index=0&id=5356661c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356661c",
  null
  
)

export default component.exports